// Shared environment types and client-side utilities

export type SystemType = "primary" | "standin" | "unknown";

/**
 * Check if the current environment is the standin/disaster recovery environment
 */
export function isStandinEnvironment(systemType: SystemType): boolean {
  return systemType === "standin";
}

/**
 * Get features that should be disabled in standin mode
 */
export function getDisabledFeaturesInStandin(): string[] {
  return [
    "playground", // AI playground functionality
    "reports", // Report generation
    // Add other features that should be disabled in standin mode
  ];
}
